var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PageWrapper',{on:{"handleBack":_vm.goToParvandehList}},[[_c('Tabs',{attrs:{"tabs":_vm.tabs,"tabContentClass":"overflow-y-hidden"},scopedSlots:_vm._u([{key:"tab-0",fn:function(){return [_c('AddParvandehForNewUser')]},proxy:true},{key:"tab-1",fn:function(){return [_c('AddParvandehForActiveUser')]},proxy:true}])})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }